import nakamaUtil from "@cardinal-entertainment/nakama-util/dist/nakama";
import Cookies from "js-cookie";
import eventsCenter, { PHASER_EVENTS } from "./phaserEvents";

const nakamaUtilInstance = nakamaUtil.getInstance(
  import.meta.env.VITE_LOCAL === "true",
  import.meta.env.VITE_NAKAMA_SERVER_KEY
);

const redirectToAuth = () => {
  console.log("redirectToAuth called, we we would be logged out now");
  nakamaUtilInstance.deleteNakamaUserCookie();
  if (import.meta.env.MODE === "development") {
    window.location.href =
      "http://localhost:3001/auth/?returnTo=" + window.location.href;
  } else {
    window.location.href =
      "https://zoombies.world/auth/?returnTo=" + window.location.href;
  }
};

const MAX_RECONNECT_ATTEMPTS = 5;
const INITIAL_RECONNECT_DELAY = 1000; // 1 second
const MAX_RECONNECT_DELAY = 30000; // 30 seconds

let reconnectAttempts = 0;
let reconnectTimeout = null;
let isIntentionallyReconnecting = false; // Flag to prevent reconnect loop when we're intentionally reconnecting
let isConcurrentDisconnect = false; // Flag to check if we've been kicked by another device

let USERNAME, user, socket, client, session, userHero, socketConnected=false;
(async () => {
  // Check for existing session cookie - no automatic user creation
  const nakamaUserSession = Cookies.get("NAKAMA_USER_SESSION");
  console.log("Authentication flow - checking for existing session cookie");
  if (nakamaUserSession) {
    try {
      const sessionData = JSON.parse(nakamaUserSession);
      console.log("Found session cookie, user_id:", sessionData.user_id || "unknown");
      console.log("Session username:", sessionData.username || "unknown");
      
      // Check if required session data exists
      if (sessionData.accessToken && sessionData.refresh_token) {
        session = await nakamaUtilInstance.refreshSession(
          sessionData.accessToken,
          sessionData.refresh_token
        );
        
        console.log("Session refreshed successfully for user:", session.user_id);
        console.log("Username:", session.username);

        if (session && session.expires_at && session.expires_at * 1000 < Date.now()) {
          console.log("Session expired, redirecting to auth", session.expires_at);
          redirectToAuth();
          return; // Exit early - redirect will navigate away
        }
      } else {
        console.log("Invalid session data (missing tokens), redirecting to auth");
        redirectToAuth();
        return; // Exit early - redirect will navigate away
      }
    } catch (error) {
      console.error("Error parsing/refreshing session data:", error);
      redirectToAuth();
      return; // Exit early - redirect will navigate away
    }
  } else {
    console.log("No session cookie found, redirecting to auth");
    // redirect user to auth - no automatic user creation
    redirectToAuth();
    return; // Exit early if no session - redirectToAuth will navigate away
  }

  // Only continue if we have a valid session
  if (!session) {
    console.log("No valid session available, redirecting to auth");
    redirectToAuth();
    return;
  }

  //console.log('SESSION', session);

  // Process session and prepare socket
  USERNAME = session.username;
  socket = nakamaUtilInstance.socket;
  client = nakamaUtilInstance.client;
  socket.verbose = false;

  // Add session refresh timer - refresh every 90 minutes for 2-hour session expiry (30min buffer)
  const REFRESH_INTERVAL = 5400 * 1000; // 5400 seconds (90 minutes) in milliseconds
  setInterval(async () => {
    try {
      // Check if session exists and is not expired before attempting refresh
      // isexpired() takes seconds, not milliseconds
      if (session && !session.isexpired(Date.now() / 1000 + 30)) { // 30 second buffer
        session = await nakamaUtilInstance.client.sessionRefresh(session);
        console.log("Session refreshed successfully");
      } else {
        console.log("Session expired or invalid, attempting reconnect");
        attemptReconnect();
      }
    } catch (error) {
      console.error("Failed to refresh session:", error);
      // Don't immediately redirect, try to reconnect first
      if (error.code === 16 || error.message?.includes('UNAUTHENTICATED')) {
        redirectToAuth();
      } else {
        attemptReconnect();
      }
    }
  }, REFRESH_INTERVAL);

  // var appearOnline = true; // Currently unused

  try {
    await connectSocket();
  } catch (error) {
    console.error("Initial socket connection failed:", error);
    attemptReconnect();
  }
  
  try {
    const account = await client.getAccount(session);
    user = account.user;

    const storage = await client.listStorageObjects(
      session,
      "user_heros",
      user.id,
      1
    );
    if (storage.objects.length !== 0) {
      userHero = storage.objects[0];
    }
  } catch (err) {
    console.log(
      "Error authenticating device: %o:%o",
      err.statusCode,
      err.message
    );
  }
  

  // Listen for notifications
  socket.onnotification = (notification) => {
    // Log browser info for debugging Safari issues
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      console.log("🔶 Safari - Notification received:", notification.code, notification);
    }
    
    //console.log("Incoming Nakama notification", notification);
    switch(notification.code){
      case -2:
        eventsCenter.emit(PHASER_EVENTS.FRIEND_REQUEST_RECEIVED, notification)
        break;
      case -3:
        eventsCenter.emit(PHASER_EVENTS.FRIEND_REQUEST_ACCEPTED, notification)
        break
      case -7:
        // System notification for socket state (single_socket)
        console.warn("🔌 Socket concurrent connection detected (code -7). Logging out...");
        isConcurrentDisconnect = true;
        redirectToAuth();
        break;
      case 102:
        eventsCenter.emit(PHASER_EVENTS.BONE_RECEIVED, notification)
        break;
      case 103:
        eventsCenter.emit(PHASER_EVENTS.BONE_COLLECTED, notification)
        break;
      case 104:
        console.log("📢 Emitting TOURNAMENT_UPDATE event");
        eventsCenter.emit(PHASER_EVENTS.TOURNAMENT_UPDATE, notification)
        break;
      case 105:
        eventsCenter.emit(PHASER_EVENTS.MATCH_RESULT, notification)
        break;
      case 1001:
        // x402 payment success
        console.log('💳 Payment success notification received:', notification);
        eventsCenter.emit(PHASER_EVENTS.PAYMENT_SUCCESS, notification);
        console.log('💳 PAYMENT_SUCCESS event emitted to eventsCenter');
        break;
      case -1:
          eventsCenter.emit(PHASER_EVENTS.CHAT_NOTIFICATION, notification)
          break;
      default:
        console.log("Unhandled notification code", notification.code, notification);
        eventsCenter.emit(PHASER_EVENTS.NOTIFICATION, notification);
    }
  };

  // DEBUG: Stream handler registration
  // console.log("🔧 Registering stream handlers...");
  socket.onstreamdata = (streamData) => {
      // console.log("🎯 STREAM DATA RECEIVED!");
      // console.log("Received data from stream:", streamData.stream.subject);
      // console.log("Data content:", streamData.data);
      try {
          const parsedData = JSON.parse(streamData.data);
          // console.log("Parsed lobby event:", parsedData);
          eventsCenter.emit(PHASER_EVENTS.LOBBY_MATCH_EVENT, parsedData);
      } catch (error) {
          // console.error("Error parsing stream data:", error);
      }
  };

  socket.onstreampresence = (presence) => {
      // console.log("👥 Stream presence update:", presence);
  };

  socket.onerror = (err) => {
      // console.log("Socket error", err);
  };

  // console.log("✅ Stream handlers registered successfully");
})();

const connectSocket = async (forceNew = false) => {
  try {
    // Set flag to prevent reconnect loop when we're intentionally reconnecting
    if (forceNew) {
      isIntentionallyReconnecting = true;
    }
    
    // Safely close existing socket if forcing new connection
    if (forceNew && socket) {
      try {
        // Check if socket is already connected before closing
        if (socket.readyState === 1) { // WebSocket.OPEN
          console.log("Closing existing socket connection before reconnecting...");
          socket.close(1000, "Reconnecting"); // Clean close with code 1000
          // Wait a bit for the close to complete
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      } catch (closeError) {
        console.log("Error closing old socket (already closed?):", closeError.message);
      }
      socket = null; // Clear the reference to get a fresh one
    }
    
    // Check if socket is already connected
    if (socket && socket.readyState === 1) {
      console.log("Socket already connected, skipping connection");
      socketConnected = true;
      isIntentionallyReconnecting = false; // Reset flag
      return true;
    }
    
    socket = nakamaUtilInstance.socket;
    await socket.connect(session, true);
    socketConnected = true;
    reconnectAttempts = 0; // Reset attempts on successful connection
    isIntentionallyReconnecting = false; // Reset flag after successful connection
    isConcurrentDisconnect = false; // Reset concurrent flag
    
    // Setup socket event handlers
    setupSocketHandlers();
    
    return true;
  } catch (error) {
    console.error("Socket connection failed:", error);
    isIntentionallyReconnecting = false; // Reset flag on error
    return false;
  }
};

const setupSocketHandlers = () => {
  socket.ondisconnect = async (evt) => {
    socketConnected = false;
    console.log("Socket disconnected:", evt);
    
    // Don't attempt reconnect if we're intentionally reconnecting
    if (isIntentionallyReconnecting) {
      console.log("Intentional reconnect in progress, ignoring disconnect event");
      return;
    }

    // Don't attempt reconnect if we've been kicked by another device
    if (isConcurrentDisconnect) {
        console.warn("Concurrent disconnect detected, aborting reconnect.");
        return;
    }
    
    // Don't attempt reconnect if this was an intentional close
    if (evt.code === 1000 || evt.code === 1001) {
      console.log("Clean disconnect, not attempting reconnect");
      return;
    }

    attemptReconnect();
  };

  socket.onconnect = () => {
    socketConnected = true;
    console.log("Socket connected successfully");
    eventsCenter.emit(PHASER_EVENTS.SOCKET_CONNECTED);
  };

  // ... other existing socket handlers ...
};

const attemptReconnect = async () => {
  if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
    console.error("Max reconnection attempts reached");
    eventsCenter.emit(PHASER_EVENTS.CONNECTION_FAILED);
    //nakamaUtilInstance.deleteNakamaUserCookie();
    redirectToAuth();
    return;
  }

  // Calculate delay with exponential backoff
  const delay = Math.min(
    INITIAL_RECONNECT_DELAY * Math.pow(2, reconnectAttempts),
    MAX_RECONNECT_DELAY
  );

  console.log(`Attempting reconnect in ${delay}ms (attempt ${reconnectAttempts + 1}/${MAX_RECONNECT_ATTEMPTS})`);

  // Clear any existing timeout
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout);
  }

  reconnectTimeout = setTimeout(async () => {
    reconnectAttempts++;

    try {
      // Try to refresh the session before reconnecting
      // isexpired() takes seconds, not milliseconds
      if (session && session.isexpired(Date.now() / 1000)) {
        try {
          session = await nakamaUtilInstance.client.sessionRefresh(session);
        } catch (refreshError) {
          console.error("Session refresh failed during reconnect:", refreshError);
          // If session refresh fails with auth error, redirect to auth
          if (refreshError.code === 16 || refreshError.message?.includes('UNAUTHENTICATED')) {
            redirectToAuth();
            return;
          }
          // For other errors, continue with reconnection attempt
        }
      }

      const connected = await connectSocket(true);
      
      if (connected) {
        console.log("Reconnection successful");
        eventsCenter.emit(PHASER_EVENTS.SOCKET_RECONNECTED);
      } else {
        attemptReconnect();
      }
    } catch (error) {
      console.error("Reconnection failed:", error);
      // Check if it's an authentication error
      if (error.code === 16 || error.message?.includes('UNAUTHENTICATED')) {
        console.log("Authentication failed during reconnect, redirecting to auth");
        redirectToAuth();
        return;
      }
      attemptReconnect();
    }
  }, delay);
};

// Add a cleanup function to clear reconnection state
const cleanup = () => {
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout);
  }
  reconnectAttempts = 0;
  socketConnected = false;
};

//Handle the session timeout lifecycle
export const sessionTimeoutCheck = async () => {
  console.log("sessionTimeoutCheck called");
  
  // Check if session exists before checking if it's expired
  if (!session) {
    console.log("Session is undefined, redirecting to auth");
    redirectToAuth();
    return;
  }
  
  // Check if session is expired using expires_at timestamp (more reliable)
  const now = Date.now() / 1000; // Convert to seconds
  const isExpired = session.expires_at && session.expires_at < now;
  
  // Also check using isexpired() method as fallback
  const isExpiredByMethod = session.isexpired ? session.isexpired(now) : false;
  
  if (isExpired || isExpiredByMethod) {
    try {
      // Only try to refresh if we have a refresh token and session hasn't been expired too long
      if (session.refresh_token && session.expires_at && (now - session.expires_at) < 300) {
        // Session expired less than 5 minutes ago, try to refresh
        session = await nakamaUtilInstance.client.sessionRefresh(session);
        console.log("Session refreshed successfully via sessionTimeoutCheck");
      } else {
        // Session expired too long ago or no refresh token, redirect immediately
        throw new Error("Session expired and cannot be refreshed");
      }
    } catch (error) {
      //Clear cookie and redirect to re-auth
      console.error("Session has timed out..redirecting", error);
      nakamaUtilInstance.deleteNakamaUserCookie();
      if(user && user.id !== 'b19c5ccd-a9be-4f62-87cf-dcf2469d8e0b'){
        redirectToAuth();
      } else {
        // Even for special user, redirect if session is expired
        redirectToAuth();
      }
    }
  }
}

export async function joinChat(room) {
  let chatChannel = await socket.joinChat(room, 1, true, false);
  return chatChannel;
}

export async function joinLobbyStream() {
    // DEBUG: Join lobby stream
    // console.log("📡 joinLobbyStream called");
    if (!socketConnected || !socket) {
        // console.log("❌ Socket not connected, will retry in 1 second...");
        // Retry after a short delay to allow socket to connect
        setTimeout(() => {
            // console.log("🔄 Retrying joinLobbyStream...");
            joinLobbyStream();
        }, 1000);
        return;
    }
    try {
        // console.log("📞 Calling joinLobby RPC...");
        const res = await socket.rpc("joinLobby", null);
        // console.log("✅ Joined lobby stream successfully:", res);
    } catch (error) {
        // console.error("❌ Error joining lobby stream:", error);
    }
}

// Get session expiry time in milliseconds
export const getSessionExpiryTime = () => {
    if (session && session.expires_at) {
        return session.expires_at * 1000; // Convert to milliseconds
    }
    return null;
};

// Extend session by refreshing it
export const extendSession = async () => {
    try {
        if (!session || !session.token || !session.refresh_token) {
            console.error("Cannot extend session: missing token or refresh_token");
            return false;
        }

        const previousExpiry = session.expires_at;

        // Hit the Nakama server for a brand-new JWT with a fresh expiry.
        // (nakamaUtilInstance.refreshSession is a local Session.restore — it does NOT extend expiry.)
        session = await nakamaUtilInstance.client.sessionRefresh(session);

        // Sanity check: if expiry didn't move forward, the refresh effectively failed.
        if (!session || !session.expires_at || session.expires_at <= previousExpiry) {
            console.error("sessionRefresh returned a session with no new expiry", { previousExpiry, newExpiry: session && session.expires_at });
            return false;
        }

        // Update the cookie with the new tokens
        Cookies.set("NAKAMA_USER_SESSION", JSON.stringify({
            accessToken: session.token,
            refresh_token: session.refresh_token,
            user_id: session.user_id,
            username: session.username
        }), { expires: 365 });

        console.log("Session extended successfully, new expiry:", new Date(session.expires_at * 1000).toLocaleString());
        
        // Reconnect socket with the new session to prevent 401 errors
        // This is critical - the socket must use the new session token
        try {
            if (socket) {
                console.log("Reconnecting socket with new session...");
                const connected = await connectSocket(true);
                if (connected) {
                    console.log("Socket reconnected successfully with new session");
                    // Wait a moment for the connection to fully establish
                    await new Promise(resolve => setTimeout(resolve, 200));
                } else {
                    console.warn("Socket reconnection returned false, but continuing...");
                }
            } else {
                console.warn("Socket not available for reconnection after session extension");
            }
        } catch (socketError) {
            console.error("Failed to reconnect socket after session extension:", socketError);
            // Don't fail the entire operation if socket reconnect fails
            // The socket will reconnect automatically on next use
        }
        
        return true;
    } catch (error) {
        console.error("Failed to extend session:", error);
        return false;
    }
};

export { USERNAME, user, socket, client, session, userHero, socketConnected, cleanup, connectSocket };
export default nakamaUtilInstance;